export default "__VITE_ASSET__c501d5c8__"